export default __webpack_public_path__ + "static/media/Logo-Completo.1bb4d5f5.png";